export const ERROR = 1;
export const DATASET_FAILED_TO_LOAD = 3;
export const CONNECTION_CONFIG_FAILED_TO_LOAD = 4;
export const FILTER_PANEL_FAILED_TO_LOAD = 5;
export const SORT_PANEL_FAILED_TO_LOAD = 6;
export const ADD_COLUMN_PANEL_FAILED_TO_LOAD = 7;
export const CHANGE_COLLECTION_PANEL_FAILED_TO_LOAD = 8;
export const CREATE_DATASET_PANEL_FAILED_TO_LOAD = 9;
export const NEW_DYNAMIC_PAGE_PANEL_FAILED_TO_LOAD = 10;
export const DELETE_DYNAMIC_PAGE_PANEL_FAILED_TO_LOAD = 11;
export const DYNAMIC_PAGE_INFO_PANEL_FAILED_TO_LOAD = 12;
export const DYNAMIC_PAGE_SEO_PANEL_FAILED_TO_LOAD = 13;
export const DYNAMIC_PAGES_HOOKS_PANEL_FAILED_TO_LOAD = 14;
export const ERROR_PANEL_FAILED_TO_LOAD = 15;
export const ADD_PRESET_PANEL_FAILED_TO_LOAD = 16;
export const ADD_FIELD_PANEL_FAILED_TO_LOAD = 17;
export const NEW_DYNAMIC_PAGE_PANEL_V3_FAILED_TO_LOAD = 18;
export const CREATE_COLLECTION_PANEL_FAILED_TO_LOAD = 19;
//# sourceMappingURL=biErrorCodes.js.map